import { useEffect, useState } from "react";
import { Bell, BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import clienteApi from "../../lib/clienteApi";

const supported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
const toKey = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};
const getReg = () => navigator.serviceWorker.register("/cliente-sw.js", { scope: "/cliente" }).then(() => navigator.serviceWorker.ready);

export const ClientePushToggle = () => {
  const [state, setState] = useState("loading");
  useEffect(() => {
    if (!supported()) { setState("unsupported"); return; }
    if (Notification.permission === "denied") { setState("denied"); return; }
    getReg().then((r) => r.pushManager.getSubscription()).then((s) => {
      if (s) clienteApi.post("/cliente/push/subscribe", { subscription: s.toJSON() }).catch(() => {});
      setState(s ? "on" : "off");
    }).catch(() => setState("off"));
  }, []);

  const enable = async () => {
    setState("loading");
    try {
      if ((await Notification.requestPermission()) !== "granted") { setState("denied"); return; }
      const { data } = await clienteApi.get("/cliente/push/key");
      const reg = await getReg();
      const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.key) });
      await clienteApi.post("/cliente/push/subscribe", { subscription: sub.toJSON() });
      setState("on");
      toast.success("Notifiche attivate su questo dispositivo");
    } catch (e) { setState("off"); toast.error("Impossibile attivare le notifiche su questo dispositivo"); }
  };
  const disable = async () => {
    setState("loading");
    const s = await (await getReg()).pushManager.getSubscription();
    if (s) { await clienteApi.post("/cliente/push/unsubscribe", { endpoint: s.endpoint }).catch(() => {}); await s.unsubscribe(); }
    setState("off");
  };

  if (state === "unsupported") return null;
  const base = "inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold transition-colors";
  if (state === "loading") return <span className={`${base} text-slate-500`}><Loader2 className="h-3.5 w-3.5 animate-spin" /><span className="hidden sm:inline">Notifiche</span></span>;
  if (state === "denied") return <span className={`${base} text-slate-500`} data-testid="cliente-push-denied" title="Riattiva le notifiche dalle impostazioni del browser"><Bell className="h-3.5 w-3.5" /><span className="hidden sm:inline">Notifiche bloccate</span></span>;
  return state === "on"
    ? <button type="button" onClick={disable} title="Notifiche attive" data-testid="cliente-push-disable" className={`${base} border border-slate-300 text-[#111827] hover:bg-slate-100`}><BellRing className="h-3.5 w-3.5 text-amber-600" /><span className="hidden sm:inline">Notifiche attive</span></button>
    : <button type="button" onClick={enable} title="Attiva notifiche" data-testid="cliente-push-enable" className={`${base} bg-amber-500 hover:bg-amber-600 text-[#0a0d14]`}><Bell className="h-3.5 w-3.5" /><span className="hidden sm:inline">Attiva notifiche</span></button>;
};
